import React from 'react';
import {render} from 'react-dom';

import WidgetEuro from '../modules/euro-2020';
import {FIFA_GROUP_MATCHES} from '../modules/euro-2020/constants/fifa2022/group-matches';
import {FIFA_GROUPS} from '../modules/euro-2020/constants/fifa2022/groups';
import {FIFA_PLAYOFF_STAGES} from '../modules/euro-2020/constants/fifa2022/play-off';
import {Theme} from '../modules/euro-2020/contexts/theme';
import TopForwards from '../modules/fifa-2022/widget-top-forwards';
import WidgetUsefulMaterials from '../modules/fifa-2022/widget-useful-materials';
import '../website-ui/i18n/config';

const isMobile = window.Site.targeting.platform === 'smartphone';

const mockData = {
  groups: FIFA_GROUPS,
  groupMatches: FIFA_GROUP_MATCHES,
  stages: FIFA_PLAYOFF_STAGES
};

render(
  <WidgetEuro
    isMobile={isMobile}
    mockData={mockData}
    theme="Fifa"
    chunkSize="4"
  />,
  document.getElementById('js-widget-fifa-2022')
);

render(
  <Theme.Provider value="Fifa">
    <WidgetUsefulMaterials />
  </Theme.Provider>,
  document.getElementById('js-widget-useful-materials')
);

render(
  <Theme.Provider value="Fifa">
    <TopForwards />
  </Theme.Provider>,
  document.getElementById('js-widget-top-forwards')
);
